export const HEADING_TEXT = {
  heading1: "SOFTWARE & DATA SERVICES (ASDS)",
  heading2: "AIRCRAFT PERSONALITY MODULE - APM",
};
